import React, { Suspense, lazy, useEffect } from 'react';
import { Redirect, Switch, Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { LayoutSplashScreen } from '../_metronic/layout';
import DashboardPage from './modules/Dashboard';
import { daysToMilliseconds } from './helper';
import { actions } from '../redux/merchants';
import Challenges from './modules/Challenges';

import Overview from './modules/Dashboard/index';
import FunFacts from './modules/FunFacts/index';
import Visibility from './modules/Visibility/Visibility';
import Welcome from './modules/Welcome/Welcome';
import Wishlist from './modules/Wishlist/Wishlist';
import MultiOverview from './modules/MultiOverview/index';
import CustomerSupport from './modules/CustomerSupport/CustomerSupport';
import Quizzes from './modules/Quizzes/index.jsx';
import Plans from './modules/Plan/index';

const Moderation = lazy(() => import('./modules/Moderation/pages/moderationPage.js'));
const Users = lazy(() => import('./modules/Users'));
const Story = lazy(() => import('./modules/Story'));
const Social = lazy(() => import('./modules/SocialMedia'));
const Posts = lazy(() => import('./modules/Posts'));
const Ambassador = lazy(() => import('./modules/Ambassador'));
const Feed = lazy(() => import('./modules/Feed'));
const Help = lazy(() => import('./modules/Help/index'));

export default function BasePage() {
	const location = useLocation();
	const dispatch = useDispatch();
	const { userMerchantId, currUser, merchants } = useSelector(
		state => ({
			currUser: state.auth.user,
			merchants: state.merchants.merchants,
			userMerchantId: state.auth.user.merchantId,
		}),
		shallowEqual,
	);

	useEffect(() => {
		const from = new Date().getTime() - daysToMilliseconds(30);
		const to = new Date().getTime()
		if (userMerchantId && merchants && merchants.length) {
			dispatch(
				actions.updateFilter({
					from,
					to,
					merchantId: userMerchantId === 'all' ? merchants[0].merchantId : userMerchantId,
				}),
			);
		}
	}, [userMerchantId, merchants, dispatch]);
	useEffect(() => {
		if (location.pathname === '/fun-facts') {
			const from = new Date().getTime() - daysToMilliseconds(30);
			const to = new Date().getTime()
			if (userMerchantId && merchants && merchants.length) {
				dispatch(
					actions.updateFilter({
						from: from,
						to: to,
					}),
				);
			}
		}
	}, [dispatch, location.pathname, merchants, userMerchantId]);

	const getRoute = (user) => {
		if (!merchants || !merchants.length) {
			return '/auth/login';
		}
		const paymentStatus = merchants[0].shopify && merchants[0].shopify?.payment_status;
		if (paymentStatus === 'active' || !merchants[0].shopify) {
			return user.profile === 'admin'
				? '/overview'
				: '/moderation';
		} else {
			return '/plans';
		}
	}

	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<Redirect exact from='/' to={getRoute(currUser)} />
				{/* 299 */}
				<Route path='/overview' component={Overview} />
				{/* 299 */}
				<Route path='/overview' component={DashboardPage} />
				<Route path='/moderation' component={Moderation} />
				<Route path='/users' component={Users} />
				<Route path='/posts' component={Posts} />
				<Route path='/feed' component={Feed} />
				<Route path='/social-media' component={Social} />
				<Route path='/ambassador' component={Ambassador} />
				<Route path='/challenges' component={Challenges} />
				<Route path='/story' component={Story} />
				{/* #299 */}
				<Route path='/help' component={Help} />
				<Route path='/quizzes' component={Quizzes} />
				<Route path='/plans' component={Plans} />
				<Route path='/visibility' component={Visibility} />
				<Route path='/fun-facts' component={FunFacts} />
				<Route path='/welcome' component={Welcome} />
				<Route path='/wishlist' component={Wishlist} />
				<Route path='/multi-overview' component={MultiOverview} />
				<Route path='/customer-support' component={CustomerSupport} />

				{/* #299 */}
			</Switch>
		</Suspense>
	);
}
